module.exports = __webpack_public_path__ + "img/uploadImg.f24afb64.svg";